import { showToast } from '../../../engine/toast';
import { adminListApiKeys, adminCreateApiKey, adminDeleteApiKey, listItems } from '../admin-api';
import { escapeHtml, BTN_CLS, INPUT_CLS, SMALL_BTN_CLS } from '../admin-ui';
import type { PaneModule } from './types';

export const keysPane: PaneModule = {
  id: 'keys',
  label: 'API keys',

  html(ctx) {
    const rows = ctx.state.keys
      .map(
        (k) => `
        <tr class="border-t border-border">
          <td class="py-2 pr-2 text-sm text-text">${escapeHtml(k.label)}</td>
          <td class="py-2 pr-2 text-[10px] text-text-dim whitespace-nowrap">${k.expiresAt ? `expires ${escapeHtml(k.expiresAt.slice(0, 10))}` : 'no expiry'}</td>
          <td class="py-2 text-right"><button type="button" class="${SMALL_BTN_CLS}" data-action="delete-key" data-id="${k.id}">Revoke</button></td>
        </tr>`,
      )
      .join('');
    return `
      <section class="flex flex-col gap-2">
        <h2 class="font-heading text-xs text-gold tracking-wide uppercase">API keys</h2>
        <p class="text-[10px] text-text-dim leading-relaxed">
          Keys authenticate external admin systems such as MAD. They are shown once, on creation, and die with their
          creator&rsquo;s admin role.
        </p>
        <form data-form="create-key" class="flex gap-2">
          <input name="label" type="text" placeholder="Label" required class="${INPUT_CLS}" />
          <button type="submit" ${ctx.state.busy ? 'disabled' : ''} class="${BTN_CLS}">Create</button>
        </form>
        <div class="glass-panel px-3 py-2 overflow-x-auto">
          <table class="w-full text-left"><tbody>${rows || '<tr><td class="py-3 text-xs text-text-dim">No keys issued.</td></tr>'}</tbody></table>
        </div>
      </section>`;
  },

  async load(ctx) {
    ctx.state.keys = listItems(await adminListApiKeys());
  },

  onAction(action, el, ctx) {
    if (action !== 'delete-key') return false;
    if (!window.confirm('Revoke this API key? Anything using it stops working immediately.')) return true;
    const id = el.dataset.id ?? '';
    void ctx.withBusy(async () => {
      await adminDeleteApiKey(id);
      showToast('Key revoked.', 'success');
      await ctx.reload('keys');
    }, 'Could not revoke that key.');
    return true;
  },

  onSubmit(kind, form, ctx) {
    if (kind !== 'create-key') return false;
    const label = String(new FormData(form).get('label') ?? '').trim();
    if (!label) return true;
    void ctx.withBusy(async () => {
      const res = await adminCreateApiKey(label);
      // Shown once and never again — the server stores only a hash.
      if (res?.key) window.prompt('Copy this key now — it will not be shown again:', res.key);
      showToast('Key created.', 'success');
      await ctx.reload('keys');
    }, 'Could not create that key.');
    return true;
  },
};
